import BigNumber from 'bignumber.js'
import { AbiDefinition } from 'ethereum-types'
import { buildContract } from './buildContract'

type Balance = {
  symbol: string
  balance: BigNumber
}

/**
 * To check ETH balance we could just use web3.eth.getBalance() method, but since
 * we want the ability of checking any ERC20 token, we need to build a suitable ABI.
 * 
 * Source: https://www.shawntabrizi.com/ethereum/ethereum-token-contract-abi-web3-erc-20-human-standard-tokens/
 */
export const minimalABI: AbiDefinition[] = [{
  constant: true,
  inputs: [{
    name: '_owner',
    type: 'address' }
  ],
  name: 'balanceOf',
  outputs: [{
    name: 'balance',
    type: 'uint256'
  }],
  type: 'function',
  stateMutability: 'view'
}, {
  constant: true,
  inputs: [],
  name: 'decimals',
  outputs: [{
    name: '',
    type: 'uint8'
  }],
  type: 'function',
  stateMutability: 'view'
}, {
  constant: true,
  inputs: [],
  name: 'symbol',
  outputs: [{
    name: '',
    type: 'string'
  }],
  type: 'function',
  stateMutability: 'view'
}]

export const fetchBalance = async (tokenAddress: string, accountAddress: string): Promise<Balance> => {
  try {
    const tokenContract = buildContract(minimalABI, tokenAddress)
    const [symbol, decimals, rawBalance] = await Promise.all([
      tokenContract.methods.symbol().call(),
      tokenContract.methods.decimals().call(),
      tokenContract.methods.balanceOf(accountAddress).call()
    ])
    const balance = new BigNumber(rawBalance).div(new BigNumber(10 ** decimals))

    return {
      symbol,
      balance
    }
  } catch (ex) {
    console.error(ex)
    throw ex // Allow it to get caught later on
  }
}
